<template>
  <!-- eslint-disable vue/no-unused-components -->
  <ChatEngine v-slot="{ chatroom, members, allMessages, interactions, input }" :activator="activator">
    <div id="chat-app" class="">
      <div
        class="chat-box chat__bg no-scroll-content chat-content-area border border-solid d-theme-border-grey-light border-t-0 border-r-0 border-b-0"
      >
        <!-- :class="{
          'sidebar-spacer--wide': clickNotClose,
          'flex items-center justify-center': activeChatUser === null}" -->
        <!-- Chatroom ID: {{ chatroom.id }} -->

        <template>
          <!-- <component
            :is="scrollbarTag"
            class="chat-content-scroll-area border border-solid d-theme-border-grey-light" :settings="settings" ref="chatLogPS" :key="$vs.rtl"
          >
            <div class="chat__log" ref="chatLog">
              <chat-log
                :userId="activeChatUser"
                v-if="activeChatUser"
              >
              </chat-log>
            </div>
          </component> -->
          <div class="chat-top-bar bg-white flex flex-row items-center">
            <!-- <div class="chat__navbar">
              <chat-navbar>
              </chat-navbar>
            </div> -->
            <vs-button disabled size="large" color="dark" type="line" icon-pack="feather" icon="icon-list" style="height: 105% !important; width: 60px !important"></vs-button>

            <span class="text-2xl pl-4">Chat Room</span>

            <vs-input disabled icon-no-border icon="icon-search" color="lightgrey" icon-pack="feather" class="mx-auto input-rounded-full w-6/12 opacity-25" />

            <UIChatMember class="pl-4" v-bind="{ members }" />
            
            <!-- DROPDOWN -->
            <vs-dropdown vs-trigger-click class="ml-auto md:block hidden cursor-pointer" disabled>
              <vs-button radius icon="icon-settings" icon-pack="feather" type="flat" size="large" color="lightgrey" />

              <vs-dropdown-menu class="w-32">
                <!-- <vs-dropdown-item>
                  <div @click="$router.push('/pages/profile').catch(() => {})" class="flex items-center">
                    <feather-icon icon="UserIcon" class="inline-block mr-2" svgClasses="w-4 h-4" />
                    <span>Profile</span>
                  </div>
                </vs-dropdown-item>
                <vs-dropdown-item>
                  <div @click="$router.push('/apps/todo').catch(() => {})" class="flex items-center">
                    <feather-icon icon="CheckSquareIcon" class="inline-block mr-2" svgClasses="w-4 h-4" />
                    <span>Tasks</span>
                  </div>
                </vs-dropdown-item>
                <vs-dropdown-item>
                  <div @click="$router.push('/apps/email').catch(() => {})" class="flex items-center">
                    <feather-icon icon="MailIcon" class="inline-block mr-2" svgClasses="w-4 h-4" />
                    <span>Inbox</span>
                  </div>
                </vs-dropdown-item> -->
              </vs-dropdown-menu>

            </vs-dropdown>

          </div>
          
          <div class="chat-message-box ">
            <UIChatMessage v-bind="{ allMessages, members }" />
          </div>
        
          <!-- <div>
            Processing Queue
            {{ processingQueue }}
          </div> -->
          <!-- <div>
            Sending Queue
            {{ sendingQueue }}
          </div> -->
          <div class="chat-input chat__input flex p-3 bg-white">
            <vs-input
              class="flex-1"
              placeholder="Type Your Message"
              v-model="input.chatMessageInput.content"
              @keyup.enter="interactions.sendMessage"
            />
            <vs-button
              type="filled"
              class="bg-primary-gradient ml-4"
              @click="interactions.sendMessage">
                {{ $t('general.message.send') }}
              </vs-button>
          </div>
        </template>
        <!-- template v-else>
          <div class="flex flex-col items-center">
              <feather-icon icon="MessageSquareIcon" class="mb-4 bg-white p-8 shadow-md rounded-full" svgClasses="w-16 h-16"></feather-icon>
              <h4 class=" py-2 px-4 bg-white shadow-md rounded-full cursor-pointer" @click.stop="toggleChatSidebar(true)">Start Conversation</h4>
          </div>
        </template> -->
      </div>
    </div>
  </ChatEngine>
</template>

<script>
/* eslint-disable vue/no-unused-components */
import ChatEngine from "./engine";
import UIChatMessage from "./ui/ChatMessage";

export default {
  components: {
    ChatEngine,
    UIChatMessage,
    UIChatMember: () => import("./ui/ChatMember")
  },
  props: {
    activator: {
      type: Array,
      required: true
    }
  }
}

</script>

<style lang="scss">
@import "@/assets/scss/vuexy/apps/chat.scss";
</style>

<style lang="scss" scoped>
.chat-box {
  height: 70vh;
  width: 80vw;
  overflow: hidden;
  position: relative;

  & .chat-top-bar {
    height: 60px;
    border-bottom: 1px solid rgb(200, 200, 200);
  }

  & .chat-member-box {
    position: absolute;
    right: 28px;
    top: 36px;
    z-index: 99999;

    & /deep/ .chatroom-member-list {
      display: inline-flex;
      height: 34px;
      min-width: 40px;
      position: absolute;
      right: 32px;
      
      & .chatroom-member-list-avatar-container {
        position: absolute;
      }
    }
  }

  & .chat-message-box {
    height: calc(100% - 120px);
    position: absolute;
    bottom: 60px;
    right: 0;
    left: 0;
    width: 100%;
    overflow-y: scroll;
    box-shadow: inset 0 6px 12px 2px rgba(0,0,0,0.1) !important;

    & .chat-message-box-inner {
      // height: 100%;
      padding-bottom: 50px;
    }
  }

  & .chat-input {
    position: absolute;
    bottom: 0;
    right: 0;
    left: 0;
    max-height: 60px;
  }
}
</style>
